import React, { useState, useEffect } from "react";
import ProgresBar from "../ProgressBar";
import StorageProgressBar from "../../storage_service/ProgressBar";
import { Link, useHistory } from "react-router-dom";
import logo from "../../../assets/images/home/logo.png";
import menu from "../../../assets/images/icons/menu.png";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  // DropdownItem,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { thunkLogoutUser } from "../../../redux/reducers/user_info/userInfoReducer";
import navigationsLinks, {
  BOXIGO_WEBSITE_LINKS,
} from "../../../constants/navigation_links";

export default function Header(props) {
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const history = useHistory();
  const [showMobileNav, setShowMobileNav] = useState(false);
  useEffect(() => {
    if (showMobileNav === true) {
      document
        .getElementsByTagName("body")[0]
        .classList.add("sidebar-restrict");
    } else if (showMobileNav === false) {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("sidebar-restrict");
    }
  }, [showMobileNav]);
  const JSX = (
    <header className="container-fluid" id="top">
      <div className="main-header row">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4">
          <div className="brand-logo-container">
            <div>
              <a href={BOXIGO_WEBSITE_LINKS.home_page}>
                  <img className="img-fluid logo" src={logo} alt="Boxigo" />
              </a>
            </div>
            <button
              type="button"
              className="nav-toggle-btn d-none"
              onClick={() => setShowMobileNav(!showMobileNav)}
            >
              <img src={menu} className="img-fluid" alt="" />
            </button>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8 navigation-container">
          <div
            className={`backdrop-container activate-navigation ${
              showMobileNav && "show-backdrop-container"
            }`}
          ></div>
          <div className="row align-items-center justify-content-center">
            <div className="col-sm-12 col-md-12 col-lg-9">
              {props.serviceType === "storage" ?<StorageProgressBar {...props}/>:
              <ProgresBar {...props} />
            }
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-3">
              <ul
                className={`home-navigation ${
                  showMobileNav && "show-home-navigation"
                }`}
              >
                <li>
                  {/* <DropdownButton
                    title="Login"
                    id="dropdown-menu-align-right"
                    className="btn-as-anchor d-inline"
                  >
                    <Dropdown.Item eventKey="1">
                      <Link to="/login">Customer</Link>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="2"
                      href={config.vendorPortal}
                      target="_Blank"
                      rel="noopener noreferrer"
                    >
                      Vendor
                    </Dropdown.Item>
                  </DropdownButton> */}
                  {userInfo.loggedIn === false && (
                    <UncontrolledDropdown className="d-inline">
                      <DropdownToggle tag="a" caret>
                        Login
                      </DropdownToggle>
                      <DropdownMenu>
                        <Link to="/login" className="dropdown-item">
                          Customer
                        </Link>
                        <Link to="/login" className="dropdown-item">
                          Vendor
                        </Link>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}
                  {userInfo.loggedIn === true && (
                    <UncontrolledDropdown className="d-inline">
                      <DropdownToggle tag="a" caret>
                        <img
                          src={
                            "https://ui-avatars.com/api/?name=" +
                            userInfo.customerName.trim().split(" ")[0] +
                            "&color=fff&background=f27051&size=35&rounded=true&length=1&bold=true"
                          }
                          alt=""
                          className="img-fluid"
                        />
                      </DropdownToggle>
                      <DropdownMenu>
                        <Link
                          to={navigationsLinks.dashboard_page}
                          className="dropdown-item"
                        >
                          My Moves
                        </Link>
                        <Link
                          to={navigationsLinks.customer_profile_page}
                          className="dropdown-item"
                        >
                          My Profile
                        </Link>
                        <Link
                          to={navigationsLinks.move_details_page}
                          className="dropdown-item"
                        >
                          Make Estimate
                        </Link>
                        <button
                          onClick={() => {
                            dispatch(
                              thunkLogoutUser({
                                status: false,
                                history: history,
                              })
                            );
                          }}
                          className="dropdown-item"
                        >
                          LOGOUT
                        </button>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}
                  {/* <div className="dropdown show d-inline">
                <a
                  className="dropdown-toggle"
                  href="navigate.in"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                    const toggle = this.state.loginTabToggle ? 0 : 1;
                    this.setState({ loginTabToggle: toggle });
                  }}
                >
                  Login
                </a>
                <div className={this.state.loginTabToggle?'dropdown-menu show':'dropdown-menu' }>
                  <a
                    className="dropdown-item  "
                    href={config.customerPortal + "login"}
                  >
                  </a>
                  <a
                    className="dropdown-item"
                    href={config.vendorPortal}
                    target="_blank"
                  >
                  </a>
                </div>
              </div> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );

  return JSX;
}
